export const profile = {
  name: 'Abubakr Ahmed',
  role: 'Full Stack Developer',
  image: { asset: { _ref: 'image-7fecbc4414ebce345a2105760caea921904e7140-1024x1024-png' } },
  summary:
    'I build React, Next.js, Node.js, CMS, CRM, dashboard, and e-commerce work for client websites and web products.',
  award: {
    label: 'Campaign Middle East - Digital Faces to Watch 2026',
    url: 'https://campaignme.com/campaigns-digital-faces-to-watch-2026-abubakr-ahmed-mohamed-full-stack-developer-creo-global/',
  },
};

export const works = [
  {
    title: 'Publishers Hub - SPC Free Zone',
    description:
      'Publisher listing and management platform for SPC Free Zone, with dashboards, permissions, and approval flow.',
    projectLink: 'https://www.spcfz.ae/publishing/publishers-listing/',
    screenshot: '/project-screenshots/publishers-hub.png',
    tags: ['Full Stack', 'Government'],
    stack: 'Laravel / Blade / Bootstrap / Vite / MySQL',
    initials: 'PH',
  },
  {
    title: 'Smart Crab',
    description:
      'Publishing storefront with Shopify, checkout, reviews, SEO, and email flows.',
    projectLink: 'https://smartcrab.ae/',
    image: { asset: { _ref: 'image-ea38380d7a58a05d80f1ee409c243660f201d550-1706x1239-png' } },
    tags: ['Full Stack', 'E-commerce'],
    stack: 'Next.js / Shopify / PostgreSQL / Resend',
    initials: 'SC',
  },
  {
    title: 'Talla Studio',
    description:
      'Multimedia portfolio with animated case studies and a contact flow.',
    projectLink: 'https://www.tallavision.com/',
    image: { asset: { _ref: 'image-dad2dbd298363a79174010916284b8c082b2976a-1715x1226-png' } },
    tags: ['Web Platforms'],
    stack: 'Next.js / Tailwind / GSAP / Spline / Resend',
    initials: 'TS',
  },
  {
    title: 'Meydan Free Zone',
    description:
      'Business setup website connected to CRM, analytics, SEO, and lead forms.',
    projectLink: 'https://www.meydanfz.ae/',
    image: { asset: { _ref: 'image-283e3ed8cee44b075d02ea32cb3554b12745170b-1875x1875-png' } },
    tags: ['Web Platforms', 'Government'],
    stack: 'WordPress / Zoho CRM / SEO / Analytics',
    initials: 'MF',
  },
  {
    title: 'Shams Free Zone',
    description:
      'Business setup website and campaign landing pages for lead capture.',
    projectLink: 'https://shamsfz.ae/',
    image: { asset: { _ref: 'image-59ea83a569f4bcd9bc619b2f083d881c4687b4b7-900x900-png' } },
    tags: ['Web Platforms', 'Government'],
    stack: 'WordPress / Zoho CRM / Landing Pages',
    initials: 'SF',
  },
  {
    title: 'Dubai South Business Hub',
    description:
      'Lead-generation platform for business setup inquiries and CRM handoff.',
    projectLink: 'https://dubaisouthbh.com/',
    image: { asset: { _ref: 'image-7ca1ccce6868d58e897487eaaaa97022d82248f9-3456x2389-webp' } },
    tags: ['Web Platforms'],
    stack: 'WordPress / Zoho CRM / Lead Capture',
    initials: 'DS',
  },
  {
    title: 'RELY Commercial Vehicles',
    description:
      'Automotive website with model pages, CMS support, location UX, and launch checks.',
    projectLink: 'https://www.cherycommercialuae.com/en',
    screenshot: '/project-screenshots/rely.png',
    tags: ['Full Stack', 'Automotive'],
    stack: 'Next.js / TypeScript / Sanity / Prisma / Vitest',
    initials: 'RY',
  },
  {
    title: 'MHERO UAE',
    description:
      'Public site and CMS work for model pages, forms, tracking, and redirects.',
    projectLink: 'https://www.mhero.ae/en',
    screenshot: '/project-screenshots/mhero.png',
    tags: ['Full Stack', 'Automotive'],
    stack: 'PHP / CodeIgniter / MySQL / Docker',
    initials: 'MH',
  },
  {
    title: 'Lepas UAE',
    description:
      'Automotive launch website with forms, email handling, analytics, and model pages.',
    projectLink: 'https://www.lepasuae.com/',
    screenshot: '/project-screenshots/lepas.png',
    tags: ['Full Stack', 'Automotive'],
    stack: 'Next.js / TypeScript / Tailwind / Resend / Zod',
    initials: 'LP',
  },
  {
    title: 'Creo Global',
    description:
      'Agency website and content surfaces with CMS, CRM, email workflows, and motion.',
    projectLink: 'https://creoglobal.co/',
    image: { asset: { _ref: 'image-f5d5089b94b9ca47f0ad7c19e3beb9169d73aa10-3432x1956-webp' } },
    tags: ['Web Platforms'],
    stack: 'Next.js / Sanity / Tailwind / GSAP / Resend',
    initials: 'CG',
  },
  {
    title: 'ONOV8',
    description:
      'SaaS company website with CMS content, CRM integration, email workflows, and motion.',
    projectLink: 'https://onov8.com/',
    image: { asset: { _ref: 'image-bf662de82cb742d69af02a3b9f41e5a1833d063b-3456x2304-jpg' } },
    tags: ['Web Platforms', 'SaaS'],
    stack: 'Next.js / Tailwind / Sanity / Zoho CRM / Resend',
    initials: 'O8',
  },
];

export const skills = [
  'React.js',
  'Next.js',
  'TypeScript',
  'JavaScript',
  'Node.js',
  'Fastify',
  'Express.js',
  'PostgreSQL',
  'Drizzle',
  'Prisma',
  'MySQL',
  'Redis',
  'Docker',
  'Cloudflare Workers',
  'GitHub Actions',
  'Tailwind CSS',
  'Sanity CMS',
  'WordPress',
  'Shopify',
  'Webflow',
  'Zoho CRM',
  'Resend',
  'GSAP',
  'Framer Motion',
];

export const skillIcons = {
  'React.js': { asset: { _ref: 'image-90bfb16ae0a965fc4fc0ad7cdb69efade488fe5b-128x128-png' } },
  'Next.js': { asset: { _ref: 'image-7ea5f84c0c90effd33362ca699905efd2a206f5c-134x134-png' } },
  TypeScript: { asset: { _ref: 'image-cacd572ee8a2abf2c636b2fbeafb6eacf9528c53-128x128-png' } },
  JavaScript: { asset: { _ref: 'image-0c2650676e2e52071941e500c63a7b6136a394cb-128x128-png' } },
  'Tailwind CSS': { asset: { _ref: 'image-57cc305a8b80c339cc56523c3c20ce848336095b-179x128-png' } },
  WordPress: { asset: { _ref: 'image-cffe1dc7f61f2364c34a60051387e063517f1a81-128x128-png' } },
  Shopify: { asset: { _ref: 'image-03a1f588cdfebb15fa5074a8ed0c898a6e410a6d-480x480-png' } },
  Webflow: { asset: { _ref: 'image-ecac1700ff9705ee9cbc726dae3eae6f1a3b54d3-250x250-png' } },
  GSAP: { asset: { _ref: 'image-aa80ff3824f8a5abb5b8f143cfe0e7b512485194-244x244-png' } },
  'Framer Motion': { asset: { _ref: 'image-903aa395ce1f78b10a2404d9e32b0a0ccef76fe2-294x294-png' } },
};

export const experiences = [
  {
    year: 'Sep 2024 - Present',
    works: [
      {
        name: 'Full Stack Developer',
        company: 'Creo Global',
        desc:
          'Build and maintain full-stack web platforms for government-sector, SaaS, automotive, and agency clients. Acting second-in-command for web delivery when needed.',
      },
    ],
  },
  {
    year: 'Aug 2022 - Sep 2024',
    works: [
      {
        name: 'Front-End Developer / IT & Digital Services Administrator',
        company: 'Leader Consulting',
        desc:
          'Built dashboards, permissions, CRUD flows, reporting, image upload pipelines, WordPress/React features, and client-facing digital systems.',
      },
    ],
  },
  {
    year: 'Sep 2020 - Jun 2022',
    works: [
      {
        name: 'Front-End Developer',
        company: 'Tuti Tech Investment Co. LTD.',
        desc:
          'Developed fintech, gift-card, and e-commerce applications with React, Next.js, API integrations, SSR/SSG, and responsive UI.',
      },
    ],
  },
];
